var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuperhero = function SvgSuperhero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "superhero_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 420.1 265.2",
    style: {
      enableBackground: "new 0 0 420.1 265.2"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".superhero_svg__st3{fill:#fff}.superhero_svg__st4{fill:#e5e6e7}.superhero_svg__st9{fill:#22a7f0}.superhero_svg__st10{fill:#1b83bb}.superhero_svg__st11{fill:#79caf6}.superhero_svg__st16{opacity:.2;fill:#fff}.superhero_svg__st17{fill:#709195}.superhero_svg__st20{fill:#b1d9d3}.superhero_svg__st29{fill:#45585c}.superhero_svg__st30{fill:#566f76}.superhero_svg__st33,.superhero_svg__st34,.superhero_svg__st35{fill-rule:evenodd;clip-rule:evenodd;fill:#2ecc71}.superhero_svg__st34,.superhero_svg__st35{fill:#22a7f0}.superhero_svg__st35{fill:#efca47}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "superhero_svg__SVGID_1_",
    cx: 207.5,
    cy: 136.7,
    r: 107.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "superhero_svg__SVGID_00000092418772030668489140000007205572690095299764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#superhero_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#superhero_svg__SVGID_00000092418772030668489140000007205572690095299764_)",
      fill: "#c6e8fb"
    },
    d: "M55.7-1h309.6v266.3H55.7z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#superhero_svg__SVGID_00000092418772030668489140000007205572690095299764_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000123402688969443510350000003673627237061084832_",
    gradientUnits: "userSpaceOnUse",
    x1: 722.703,
    y1: 67.279,
    x2: 826.545,
    y2: 67.279,
    gradientTransform: "scale(1 -1) rotate(-45 157.337 738.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#superhero_svg__SVGID_00000123402688969443510350000003673627237061084832_)"
    },
    d: "M123.6 218c-.3-.2-.5-.4-.8-.6l-48-48c-.2-.2-.4-.4-.5-.6-5-5.7-5.8-13.8-2.6-20.4.1-.2.2-.4.3-.7.1-.2.2-.4.4-.6v-.1c.1-.2.2-.4.4-.6v-.1c.1-.2.3-.4.4-.6.1-.2.3-.4.4-.6v-.1c.1-.2.3-.4.4-.5l.1-.1c.1-.2.3-.3.5-.5 0 0 0-.1.1-.1.2-.2.3-.4.5-.5 7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8l.4.4.1.1c.1.1.2.2.2.3l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2.2.2.2.2c.1.1.1.2.2.2.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.1.3 0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3v.2c0 .1.1.2.1.4v.2c0 .1.1.2.1.4v.1c0 .1.1.2.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4V179.7c0 .2 0 .3-.1.5 0 .2 0 .3-.1.5 0 .2-.1.3-.1.5s-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.2.5-.1.3-.2.5-.1.3-.2.5c-.9 2.4-2.2 4.6-3.9 6.7 5.7 7.3 5.2 18-1.5 24.7-6.8 7.1-17.7 7.5-25 1.4z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st3",
    d: "M147 192.1c7.7-9.1 7.2-22.6-1.3-31.2-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-7 7-7.3 18.1-1 25.4.2.2.3.4.5.6l48 48c.2.2.5.5.8.6 7.3 6.1 18.2 5.7 25.1-1.2 6.6-6.8 7.1-17.4 1.4-24.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st4",
    d: "M69.3 147.4c7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8 7.3 7.3 8.7 18.2 4.2 26.9 7.5-9.1 7-22.5-1.5-31-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-1.5 1.5-2.7 3.2-3.6 5l.9-.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000141454001127320899360000002405748514803081617_",
    gradientUnits: "userSpaceOnUse",
    x1: 823.991,
    y1: 77.616,
    x2: 927.834,
    y2: 77.616,
    gradientTransform: "scale(1 -1) rotate(-45 157.337 738.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#superhero_svg__SVGID_00000141454001127320899360000002405748514803081617_)"
    },
    d: "M202.5 282.3c-.3-.2-.5-.4-.8-.6l-48-48c-.2-.2-.4-.4-.5-.6-5-5.7-5.8-13.8-2.6-20.4.1-.2.2-.4.3-.7.1-.2.2-.4.4-.6v-.1c.1-.2.2-.4.4-.6v-.1c.1-.2.3-.4.4-.6.1-.2.3-.4.4-.6v-.1c.1-.2.3-.4.4-.5l.1-.1c.1-.2.3-.3.5-.5 0 0 0-.1.1-.1.2-.2.3-.4.5-.5 7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8l.4.4.1.1c.1.1.2.2.2.3l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2.2.2.2.2c.1.1.1.2.2.2.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.1.3 0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3v.2c0 .1.1.2.1.4v.2c0 .1.1.2.1.4v.1c0 .1.1.2.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4V244c0 .2 0 .3-.1.5 0 .2 0 .3-.1.5 0 .2-.1.3-.1.5s-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.2.5-.1.3-.2.5-.1.3-.2.5c-.9 2.4-2.2 4.7-3.9 6.7 5.7 7.3 5.2 18-1.5 24.7-6.8 7.1-17.7 7.5-25 1.4z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st3",
    d: "M225.9 256.4c7.7-9.1 7.2-22.6-1.3-31.2-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-7 7-7.3 18.1-1 25.4.2.2.3.4.5.6l48 48c.2.2.5.5.8.6 7.3 6.1 18.2 5.7 25.1-1.2 6.6-6.8 7.1-17.4 1.4-24.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st4",
    d: "M148.3 211.7c7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8 7.3 7.3 8.7 18.2 4.2 26.9 7.5-9.1 7-22.5-1.5-31-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-1.5 1.5-2.7 3.2-3.6 5 .2-.2.5-.6.9-.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000057841060156949763500000006323307830047921047_",
    gradientUnits: "userSpaceOnUse",
    x1: 754.727,
    y1: -994.667,
    x2: 858.569,
    y2: -994.667,
    gradientTransform: "rotate(45.001 -924.643 -1186.401)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#superhero_svg__SVGID_00000057841060156949763500000006323307830047921047_)"
    },
    d: "M172.7 214.9c1.7-2 3-4.3 3.9-6.7.1-.2.1-.3.2-.5s.1-.3.2-.5.1-.3.2-.5c0-.2.1-.3.1-.5s.1-.3.1-.5.1-.3.1-.5.1-.3.1-.5.1-.3.1-.5.1-.3.1-.5 0-.3.1-.5c0-.2 0-.3.1-.5v-5.4c0-.1 0-.3-.1-.4v-.1c0-.1 0-.3-.1-.4v-.1c0-.1 0-.3-.1-.4v-.1c0-.1 0-.3-.1-.4v-.1c0-.1-.1-.2-.1-.4v-.1c0-.1-.1-.2-.1-.4v-.2c0-.1-.1-.2-.1-.4v-.2c0-.1-.1-.2-.1-.3 0-.1 0-.1-.1-.2 0-.1-.1-.2-.1-.3 0-.1 0-.1-.1-.2 0-.1-.1-.2-.1-.3 0-.1 0-.1-.1-.2 0-.1-.1-.2-.1-.3 0-.1 0-.1-.1-.2 0-.1-.1-.2-.1-.3 0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.1-.1-.2s-.1-.2-.1-.3c0-.1-.1-.1-.1-.2-.1-.1-.1-.2-.2-.2l44.6-44.6-11.5-11.5-46.4 46.4c-4.1-1.1-8.4-1.1-12.5.1-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0l-.5.5s0 .1-.1.1l-.5.5-.1.1c-.1.2-.3.4-.4.5v.1c-.1.2-.3.4-.4.6-.1.2-.3.4-.4.6v.1c-.1.2-.2.4-.4.6v.1c-.1.2-.2.4-.4.6-.1.2-.2.4-.3.7-3.2 6.6-2.3 14.6 2.6 20.4.2.2.3.4.5.6l48 48c.2.2.5.5.8.6 7.3 6.1 18.2 5.7 25.1-1.2 6.3-6.7 6.8-17.4 1.1-24.7z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 193.471 153.514)",
    className: "superhero_svg__st3",
    d: "M139.6 145.4h107.7v16.3H139.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st3",
    d: "M169.4 214.9c7.7-9.1 7.2-22.6-1.3-31.2-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-7 7-7.3 18.1-1 25.4.2.2.3.4.5.6l48 48c.2.2.5.5.8.6 7.3 6.1 18.2 5.7 25.1-1.2 6.7-6.8 7.2-17.4 1.4-24.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st4",
    d: "m207.4 131.3-1.6-1.6-48 48c-4-1.1-8.3-1-12.3.1-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-1.5 1.5-2.7 3.2-3.6 5 .3-.3.6-.7.9-1 7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 4.5-1.3 9.3-1.2 13.7.3l50.9-50.8zM171.1 187.4l46.2-46.2-1.6-1.6-49.3 49.3c6.4 7.3 7.5 17.6 3.2 25.8 6.5-7.9 7-19 1.5-27.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000134940638463764093660000015706119529252006042_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.926,
    y1: 82.785,
    x2: 766.769,
    y2: 82.785,
    gradientTransform: "scale(1 -1) rotate(-45 157.337 738.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#superhero_svg__SVGID_00000134940638463764093660000015706119529252006042_)"
    },
    d: "M92.3 164.8c-.3-.2-.5-.4-.8-.6l-48-48c-.2-.2-.4-.4-.5-.6-5-5.7-5.8-13.8-2.6-20.4.1-.2.2-.4.3-.7.1-.2.2-.4.4-.6v-.1c.1-.2.2-.4.4-.6v-.1c.1-.2.3-.4.4-.6.1-.2.3-.4.4-.6v-.1c.1-.2.3-.4.4-.5l.1-.1c.1-.2.3-.3.5-.5 0 0 0-.1.1-.1.2-.2.3-.4.5-.5 7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8l.4.4.1.1c.1.1.2.2.2.3l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2.2.2.2.2c.1.1.1.2.2.2.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.1.2 0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3v.2c0 .1.1.2.1.4v.2c0 .1.1.2.1.4v.1c0 .1.1.2.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4V126.4c0 .2 0 .3-.1.5 0 .2 0 .3-.1.5 0 .2-.1.3-.1.5s-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.2.5-.1.3-.2.5-.1.3-.2.5c-.9 2.4-2.2 4.6-3.9 6.7 5.7 7.3 5.2 18-1.5 24.7-6.8 7.2-17.7 7.6-25 1.5z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st3",
    d: "M115.7 138.8c7.7-9.1 7.2-22.6-1.3-31.2-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-7 7-7.3 18.1-1 25.4.2.2.3.4.5.6l48 48c.2.2.5.5.8.6 7.3 6.1 18.2 5.7 25.1-1.2 6.6-6.7 7.1-17.3 1.4-24.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st4",
    d: "M38 94.2c7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8 7.3 7.3 8.7 18.2 4.2 26.9 7.5-9.1 7-22.5-1.5-31-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-1.5 1.5-2.7 3.2-3.6 5l.9-.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000114777984124545551350000017441284205835438013_",
    gradientUnits: "userSpaceOnUse",
    x1: 768.764,
    y1: 43.288,
    x2: 872.606,
    y2: 43.288,
    gradientTransform: "scale(1 -1) rotate(-45 157.337 738.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#superhero_svg__SVGID_00000114777984124545551350000017441284205835438013_)"
    },
    d: "M139.2 267.6c-.3-.2-.5-.4-.8-.6l-48-48c-.2-.2-.4-.4-.5-.6-5-5.7-5.8-13.8-2.6-20.4.1-.2.2-.4.3-.7.1-.2.2-.4.4-.6v-.1c.1-.2.2-.4.4-.6v-.1c.1-.2.3-.4.4-.6.1-.2.3-.4.4-.6v-.1c.1-.2.3-.4.4-.5l.1-.1c.1-.2.3-.3.5-.5 0 0 0-.1.1-.1.2-.2.3-.4.5-.5 7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8l.4.4.1.1c.1.1.2.2.2.3l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2l.2.2.2.2.2.2c.1.1.1.2.2.2.1.1.1.2.2.2l.2.2c.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.2.2 0 .1.1.1.1.2.1.1.1.2.1.2 0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1.1.1.1.2s.1.2.1.3c0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1 0 .1.1.2 0 .1.1.2.1.3v.2c0 .1.1.2.1.4v.2c0 .1.1.2.1.4v.1c0 .1.1.2.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4v.1c0 .1 0 .3.1.4V229.2c0 .2 0 .3-.1.5 0 .2 0 .3-.1.5 0 .2-.1.3-.1.5s-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.1.5-.1.3-.2.5-.1.3-.2.5-.1.3-.2.5c-.9 2.4-2.2 4.6-3.9 6.7 5.7 7.3 5.2 18-1.5 24.7-6.8 7.1-17.7 7.5-25 1.5z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st3",
    d: "M162.6 241.6c7.7-9.1 7.2-22.6-1.3-31.2-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-7 7-7.3 18.1-1 25.4.2.2.3.4.5.6l48 48c.2.2.5.5.8.6 7.3 6.1 18.2 5.7 25.1-1.2 6.6-6.7 7.1-17.4 1.4-24.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st4",
    d: "M84.9 196.9c7.3-7.3 19.1-7.3 26.4 0 1 1 1.9 2.1 2.6 3.3 6.5-2.1 13.8-.5 18.9 4.6 1.2 1.2 2.1 2.4 2.9 3.8 7.8-2.3 16.6-.3 22.7 5.8 7.3 7.3 8.7 18.2 4.2 26.9 7.5-9.1 7-22.5-1.5-31-6.1-6.1-14.9-8.1-22.7-5.8-.8-1.4-1.8-2.6-2.9-3.8-5.1-5.1-12.5-6.6-18.9-4.6-.7-1.2-1.6-2.3-2.6-3.3-7.3-7.3-19.1-7.3-26.4 0-1.5 1.5-2.7 3.2-3.6 5 .3-.2.6-.5.9-.9z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st9",
    d: "M279.4 91s11.1 22.8-17.2 35.4c0 0 4.4-6.6 2.3-14.7-1.3-4.8-4-6.1-4-6.1-2.1-6.9 11.4-20.8 18.9-14.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st10",
    d: "M279.4 91s.7 1.5 1.3 3.9c-3.9 2.6-10.2 6.9-12 11.7-1.8 4.7.1 10.2-2.6 15.2-.9 1.7-2.1 3-3.3 4.3l-.6.3s4.4-6.6 2.3-14.7c-1.3-4.8-4-6.1-4-6.1-2.1-6.9 11.4-20.8 18.9-14.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st11",
    d: "M276.7 112.6c2.8-2.2 4.9-10.2 3.4-13.1-.3-.5-1-.6-1.4-.2-2.2 2.1.6 7.3-2 13.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "superhero_svg__SVGID_00000150088666676000801700000010908733167861371061_",
    cx: 116.129,
    cy: 179.69,
    r: 59.036,
    gradientTransform: "rotate(-3.341 -1109.114 -1895.133)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f4d24e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ea9c4b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000150088666676000801700000010908733167861371061_)"
    },
    d: "M229.7 95.5s-10.8-4.5-22.8 3.2-13.8 19.9-13.8 19.9 5.2-3.5 9.4-3.5c0 0-13 13-8.2 39.1 0 0 4.3-2.9 15.7-5.6 10.9-2.6 15.5-9.6 15.5-9.6s-1 7.9-4.3 10.4c0 0 13.8-.1 20.8-11 7.1-10.9 6.2-22.5 4.3-28-2-5.5-16.6-14.9-16.6-14.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "superhero_svg__SVGID_00000071554201404453159150000018437512461181096370_",
    cx: 117.194,
    cy: 180.051,
    r: 41.374,
    gradientTransform: "rotate(-3.341 -1109.114 -1895.133)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fdef70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f4d24e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000071554201404453159150000018437512461181096370_)"
    },
    d: "M231.3 98.5s-14.7-1.2-24 10.8c0 0 4 2.3 9.9 2.1 0 0-11.2 9.2-11.6 26.5 0 0 6.9.2 12-1.9 9.1-3.7 11.5-8.8 11.5-8.8s1.1 5.2-.3 8.4c0 0 14.9-3.1 15.7-23.3.9-22.3-13.2-13.8-13.2-13.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "superhero_svg__SVGID_00000049185664691498444100000012612308429656045494_",
    cx: 815.237,
    cy: -1118.094,
    r: 29.318,
    gradientTransform: "rotate(45.001 -944.865 -1202.556)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#fdef70"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000049185664691498444100000012612308429656045494_)"
    },
    d: "M235.1 99.8c-5 1-7.8 5.2-8.9 8.5-1.6 4.5-1.6 7.6-3.7 12 7.6-.9 18.9-2.5 20.8-12.7-.5-8.1-2.7-10.4-5.8-10.8-2 0-.1 2.5-2.4 3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000173140747833650477160000016619810010362799508_",
    gradientUnits: "userSpaceOnUse",
    x1: 801.329,
    y1: -1120.921,
    x2: 829.22,
    y2: -1120.921,
    gradientTransform: "rotate(45.001 -944.865 -1202.556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5d777f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    style: {
      stopColor: "#556d73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45585c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000173140747833650477160000016619810010362799508_)"
    },
    d: "M239.9 89.1s-3.9.7-9.9 3.2c-1.5.6-1.7 2-1 3.5 1.9 4 6.2 11.2 16.2 16.9 1.4.8 3 1 3.8-.4 1.8-3.1 4.4-8.7 3.4-12.7-1.5-5.8-12.5-10.5-12.5-10.5z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st16",
    d: "M252.4 99.7c-.3-1.3-.1-1.3-1.1-2.4-.6 6.2-2.8 12.8-6.2 15.2.2.1.3.2.5.3 1.4.8 2.6 1 3.4-.4 1.8-3.1 4.4-8.7 3.4-12.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st17",
    d: "M242.2 90.3c-5.2 1.2-13 3.5-12.2 7.2.7 1.3 1.7 2.8 3 4.4 2.4-4.5 7-7.1 11.5-10.3-.8-.5-1.6-1-2.3-1.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000026877603694845464360000011504364764542952866_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.309,
    y1: -1130.111,
    x2: 828.548,
    y2: -1130.111,
    gradientTransform: "rotate(45.001 -944.865 -1202.556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5d777f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    style: {
      stopColor: "#556d73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45585c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000026877603694845464360000011504364764542952866_)"
    },
    d: "M242 84.1s-4.1 1.2-4.2 4.3c-.1 3.1 12 16.2 16 16.8 4 .6 4.9-7.2 4.9-7.2s-7.5-16.8-16.7-13.9z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st16",
    d: "M250.7 103.6c1.2.9 2.3 1.5 3.1 1.6 4 .6 4.9-7.2 4.9-7.2s-.6-1.3-1.6-3.1c-1.1 4.1-2.1 8.2-6.4 8.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st9",
    d: "M250.2 61.8S227.4 50.7 214.8 79c0 0 6.6-4.4 14.7-2.3 4.8 1.3 6.1 4 6.1 4 6.9 2.1 20.8-11.4 14.6-18.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st10",
    d: "M250.2 61.8s-1.5-.7-3.9-1.3c-2.6 3.9-6.9 10.2-11.7 12-4.7 1.8-10.2-.1-15.2 2.6-1.7.9-3 2.1-4.3 3.3l-.3.6s6.6-4.4 14.7-2.3c4.8 1.3 6.1 4 6.1 4 6.9 2.1 20.8-11.4 14.6-18.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "superhero_svg__SVGID_00000038391762998630148690000000147193364423550618_",
    gradientUnits: "userSpaceOnUse",
    x1: 791.851,
    y1: -1179.393,
    x2: 837.83,
    y2: -1179.393,
    gradientTransform: "rotate(45.001 -944.865 -1202.556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#96b9b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#82a2a1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000038391762998630148690000000147193364423550618_)"
    },
    d: "M319.2 23s-11.9-3.3-31.6 4.6c-7.6 3.7-16 9.5-24.7 18.1-18.1 18.1-25.1 29.8-27.3 34.2-.5 1-.1 2.3 1 2.8 0 0 .1 0 .1.1 9.5 4.6 17.1 12.2 21.7 21.7 0 0 0 .1.1.1.5 1.1 1.8 1.5 2.8 1 4.4-2.2 16-9.1 34.2-27.3 8.7-8.7 14.5-17.3 18.2-24.9 8.1-20.2 5.5-30.4 5.5-30.4z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st10",
    d: "M313.7 53.3c9.1-18.6 6.4-32.2 6.4-32.2s-13.8-2.7-32.5 6.5c0 0 16.6 9.4 26.1 25.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st20",
    d: "M300.6 40c-.5.1-1 .6-.8 1.3.2.6.8.9 1.4.8.6-.2.9-.8.7-1.4-.2-.6-.8-.8-1.3-.7zM289.4 30.2c-7.5 2.9-28.7 18.3-50 51.5-.3.5-.1 1.1.4 1.4 1.4.8 2.8 1.5 4.5 2.7.4.3 1.1.2 1.4-.2 16.4-23.6 31.2-36.7 50.4-50.5-1.2-1.2-4.6-3.6-6.7-4.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st11",
    d: "M319.2 21.3c-.3 0-16.5.1-27.4 7.7 1.6.7 5.5 3.8 6.4 4.9 6.5-4.6 13.9-8.9 21-12.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st20",
    d: "m294.5 34.9-.1.1c-.3.3-.4.8-.1 1.1.3.4 1.1.4 1.5.2.4-.2.6-.8.4-1.2-.2-.3-.5-.5-.8-.5-.4.1-.7.1-.9.3zM288.1 30.6c-.2.3-.1.7.2.9.3.2.7.2 1 .1.2 0 .3-.1.5-.2.4-.3.1-1-.3-1.2-.5-.2-1.1 0-1.4.4zM307 47.5l-.1.1c-.3.3-.8.4-1.1.1-.4-.3-.4-1.1-.2-1.5.2-.4.8-.6 1.2-.4.3.2.5.5.5.8 0 .4-.1.7-.3.9zM311.2 53.8c-.3.2-.7.1-.9-.2-.2-.3-.2-.7-.1-1 0-.2.1-.3.2-.5.3-.4 1-.1 1.2.3.2.5.1 1-.4 1.4.1-.1.1 0 0 0z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st17",
    d: "M242.6 86.4s-3.9 1.5-3.4 3.5c.1.5 2 3.1 2 3.1s.6-3.1 3.6-4.7l-2.2-1.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st11",
    d: "M228.6 64.5c2.2-2.8 10.2-4.9 13.1-3.4.5.3.6 1 .2 1.4-2.1 2.2-7.3-.6-13.3 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.2 22c-1.8 20.1-8.7 35.5-26.8 53.7-21.2 21.2-34.5 29.2-36.6 25.5.6 1 1.2 2.1 1.7 3.2 0 0 0 .1.1.1.5 1.1 1.6 1.6 2.7 1.1 4.4-2.2 16-9.1 34.2-27.3C322.1 51.5 320.8 27 320.2 22z",
    style: {
      opacity: 0.24,
      fill: "#fff"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "superhero_svg__st20",
    cx: 286.7,
    cy: 53.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 285.5,
    cy: 55.6,
    r: 10.8,
    style: {
      fill: "#d6d9db"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "superhero_svg__SVGID_00000160875977049845688130000001746164787969311656_",
    cx: 810.798,
    cy: -1191.508,
    r: 17.829,
    gradientTransform: "rotate(45.001 -944.865 -1202.556)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#566f76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45585c"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000160875977049845688130000001746164787969311656_)"
    },
    cx: 286.3,
    cy: 54.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "superhero_svg__SVGID_00000016059237593436625790000005936196252940103343_",
    cx: 812.129,
    cy: -1186.514,
    r: 10.476,
    gradientTransform: "rotate(45.001 -944.865 -1202.556)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79caf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22a7f0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#superhero_svg__SVGID_00000016059237593436625790000005936196252940103343_)"
    },
    cx: 286.3,
    cy: 54.8,
    r: 7.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7 49.4c-3-3-7.8-3-10.8 0-3 3-3 7.8 0 10.8-2.5-2.5-2.5-6.7 0-9.2 2.5-2.5 6.7-2.5 9.2 0 2.5 2.5 2.5 6.7 0 9.2s-6.7 2.5-9.2 0c3 3 7.8 3 10.8 0 2.9-3 2.9-7.8 0-10.8z",
    style: {
      fill: "#63acd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.5 60.6c-3.2-3.2-3.2-8.4 0-11.5 3.2-3.2 8.4-3.2 11.5 0 3.2 3.2 3.2 8.4 0 11.5-3.1 3.2-8.3 3.2-11.5 0zm10.8-10.8c-2.8-2.8-7.2-2.8-10 0s-2.8 7.2 0 10 7.2 2.8 10 0c2.7-2.8 2.7-7.2 0-10z",
    style: {
      fill: "#3e5053"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.8 46 .1-.1c.1 0 .2-.1.3-.2.3-.1.7-.3 1.2-.5.1 0 .3-.1.4-.1.1 0 .3-.1.4-.1.3-.1.6-.1.9-.2.3 0 .7-.1 1-.1h1.6c.2 0 .3.1.5.1.3.1.7.2 1 .3l.9.3c.1.1.3.1.4.2.1.1.2.1.4.2s.4.3.6.4c.2.1.3.3.4.4.2.2.4.3.4.3.1.1.1.2 0 .2-.1.1-.1.1-.2 0 0 0-.1-.1-.4-.2-.1-.1-.3-.2-.5-.3l-.6-.3c-.1 0-.2-.1-.3-.2-.1 0-.3-.1-.4-.1-.3-.1-.5-.2-.8-.2-.1 0-.3-.1-.4-.1-.1 0-.3 0-.5-.1-.2 0-.3 0-.5-.1h-2.4c-.3 0-.6.1-.9.1-.3 0-.5.1-.8.1-.2 0-.5.1-.7.1-.2.1-.4.1-.5.1-.1 0-.2.1-.3.1h-.1c-.1 0-.2 0-.2-.1-.1.3 0 .2 0 .1z",
    style: {
      fill: "#8fb4b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st17",
    d: "M292.2 62.9c-.2.1-.3.2-.4.3-.3.2-.6.4-1.1.6-.1.1-.2.1-.4.2-.1.1-.3.1-.4.2l-.9.3c-.3.1-.6.2-1 .2-.3 0-.7.1-1 .1h-1c-.3 0-.7-.1-1-.1-.3 0-.6-.1-.9-.2-.1 0-.3-.1-.4-.1-.1-.1-.3-.1-.4-.2-.2-.1-.5-.2-.6-.3-.2-.1-.3-.2-.5-.3-.3-.2-.4-.2-.4-.2-.1 0-.1-.1 0-.2 0 0 .1-.1.1 0l.4.2c.1.1.3.1.5.2s.4.1.6.2c.1 0 .2.1.4.1.1 0 .3.1.4.1.3.1.6.1.9.1h2c.3 0 .6-.1 1-.1.3-.1.6-.1.9-.2.3-.1.6-.1.9-.2.3-.1.5-.2.8-.3.2-.1.4-.2.6-.2.2-.1.3-.1.5-.2.1-.1.2-.1.3-.1.1 0 .1-.1.1-.1.1 0 .1 0 .2.1-.1 0-.1.1-.2.1z",
    style: {
      opacity: 0.8
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st10",
    d: "M287.7 59.7c-.4 1.2-2 1.7-3.5 1.1-1.5-.6-2.3-2-1.9-3.1.4-1.2 2-1.7 3.5-1.1 1.5.5 2.4 2 1.9 3.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st3",
    d: "M287.3 50.4c-.1.7-.9 1.3-1.8 1.2-.9-.1-1.6-.8-1.5-1.5.1-.7.9-1.3 1.8-1.2.9 0 1.6.7 1.5 1.5zM289.8 51.5c-.2.4-.7.5-1.2.3s-.7-.8-.5-1.1.7-.5 1.2-.3.7.7.5 1.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st29",
    d: "M230 92.4c-1.5.6-2.1 2.4-1.4 3.8 1.9 4 6.6 11.5 16.6 17.2 1.4.8 3.1.3 3.9-1 .1-.1-4.6-.7-11.9-8.3-8.2-8.5-7.1-11.8-7.2-11.7zM238.5 86.4c-.5.6-.8 1.3-.8 2.1-.1 3.1 12 16.2 16 16.8.9.1 1.7-.2 2.3-.8-4.5.6-17.7-14.4-17.5-18.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st30",
    d: "M300.2 39.6c-.5.1-1 .6-.8 1.3.2.6.8.9 1.4.8.6-.2.9-.8.7-1.4-.2-.6-.8-.8-1.3-.7zM294 34.5l-.1.1c-.3.3-.4.8-.1 1.1.3.4 1.1.4 1.5.2.4-.2.6-.8.4-1.2-.2-.3-.5-.5-.8-.5-.4.1-.7.2-.9.3zM287.8 30.3c-.2.3-.1.7.2.9.3.2.7.2 1 .1.2 0 .3-.1.5-.2.4-.3.1-1-.3-1.2-.5-.2-1.1 0-1.4.4zM306.6 47.2l-.1.1c-.3.3-.8.4-1.1.1-.4-.3-.4-1.1-.2-1.5.2-.4.8-.6 1.2-.4.3.2.5.5.5.8 0 .3-.1.6-.3.9zM310.8 53.4c-.3.2-.7.1-.9-.2-.2-.3-.2-.7-.1-1 0-.2.1-.3.2-.5.3-.4 1-.1 1.2.3.2.5.1 1.1-.4 1.4.1 0 .1 0 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.3 223.6 1.2 3.4c.1.4.5.6.9.6l3.5.1c.9 0 1.3 1.2.6 1.8l-2.8 2.2c-.3.2-.5.7-.3 1.1l1 3.4c.3.9-.7 1.6-1.5 1.1l-3-2c-.3-.2-.8-.2-1.1 0l-2.9 2c-.8.5-1.8-.2-1.5-1.1l1-3.5c.1-.4 0-.8-.3-1.1l-2.8-2.1c-.7-.6-.4-1.7.6-1.8l3.6-.1c.4 0 .8-.3.9-.7l1.2-3.3c.1-.8 1.3-.8 1.7 0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1b83bb"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st33",
    d: "M143 129.2c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4 1.5-3.4 3.4-3.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st34",
    d: "M298.3 172.5c2.9 0 5.2 2.3 5.2 5.2 0 2.9-2.3 5.2-5.2 5.2s-5.2-2.3-5.2-5.2c0-2.8 2.3-5.2 5.2-5.2zm0 2.4c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st35",
    d: "m331.4 58.6-5.4-6.7c-.2-.3-.2-.7.1-.9l6.7-5.4c.3-.2.7-.2.9.1l5.4 6.7c.2.3.2.7-.1.9l-6.7 5.4c-.3.2-.7.2-.9-.1zm.5-3.1c.1.1.3.2.5 0l3.5-2.8c.1-.1.2-.3 0-.5l-2.8-3.5c-.1-.1-.3-.2-.5 0l-3.5 2.8c-.1.1-.2.3 0 .5l2.8 3.5zM81.5 152.5l4.8-4.8c.2-.2.5-.2.7 0l4.8 4.8c.2.2.2.5 0 .7L87 158c-.2.2-.5.2-.7 0l-4.8-4.8c-.2-.2-.2-.5 0-.7zm2.5.2c-.1.1-.1.3 0 .4l2.5 2.5c.1.1.3.1.4 0l2.5-2.5c.1-.1.1-.3 0-.4l-2.5-2.5c-.1-.1-.3-.1-.4 0l-2.5 2.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st34",
    d: "M244.1 201.9c1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9-.1-1.6 1.3-2.9 2.9-2.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "superhero_svg__st33",
    d: "m285.3 234.2-5.4-6.7c-.2-.3-.2-.7.1-.9l6.7-5.4c.3-.2.7-.2.9.1l5.4 6.7c.2.3.2.7-.1.9l-6.7 5.4c-.3.2-.7.2-.9-.1zm.6-3.1c.1.1.3.2.5 0l3.5-2.8c.1-.1.2-.3 0-.5l-2.8-3.5c-.1-.1-.3-.2-.5 0l-3.5 2.8c-.1.1-.2.3 0 .5l2.8 3.5z"
  }))));
};

export { SvgSuperhero as ReactComponent };
export default __webpack_public_path__ + "90f2dcf43b0680ee6adf33d54b593fde.svg";